import { ArcaptchaWidget } from "arcaptcha-react";

export default function Arcaptcha() {
  return <ArcaptchaWidget site-key={import.meta.env.VITE_ARCAPTCHA_SITE_KEY} />;
}
